/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_LegalInputs */

const fr_about_legal = /** @type {(inputs: About_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentions légales`)
};

const en_about_legal = /** @type {(inputs: About_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal notice`)
};

/**
* | output |
* | --- |
* | "Legal notice" |
*
* @param {About_LegalInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const about_legal = /** @type {((inputs?: About_LegalInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_LegalInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_about_legal(inputs)
	return en_about_legal(inputs)
});